export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/index.js
// module id = 220
// module chunks = 0